import React, { useContext, useState } from 'react';
import { Dialog } from '@mui/material';
import ScanChequeCta from './ScanChequeCta';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg"
import AAutoComplete from '../../../../common/form-fields-mui/AAutoComplete';
import AInput from '../../../../common/formFeilds/customInput/AInput';
import UploadDocument from './UploadDocument';
import AButton from '../../../../common/form-fields-mui/AButton';
import SelectStatus from './SelectStatus';
import styles from "./styles.module.scss"
import { addEditBankDetails, bankAccountTypes, studentRelationDropdown, userTypes } from './utils';
import DocUploadModal from '../../../../unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import { regex } from '../../../../common/constant';
import { failureToast, successToast } from '../../../../common/utils/methods/toasterFunctions/function';
import { getFormatedDate } from '../../../../unAssigned/concessionApproval/common';
import ApprovalSentSuccessDialog from '../../../../unAssigned/examCharges/examChargesDetails/dialogs/ApprovalSentSuccessDialog';
import { UserDetails } from '../../../../../../../appContext';
import ALoader from '../../../../common/a-loader';


const AddEditBankAccountDialog = ({
    dialogInfo,
    setDialogInfo,
    dropdownData = {},
    // setLoading,
    getAllBankAccounts
}) => {

    const { isOpen, forEdit, initialForm = {}, viewOnly = false } = dialogInfo;
    const [accountDetailsForm, setAccountDetailsForm] = useState(initialForm);
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [loading , setLoading] = useState(false);

    const [addEditSuccessDialogOpen, setAddEditSuccessDialogOpen] = useState(false);

    const { allCountries, allBanks } = dropdownData;

    const { updatedBy, updatedOn } = accountDetailsForm;

    const userDetails = useContext(UserDetails);


    const closeDialog = () => setDialogInfo({});

    const formHandler = (key, value) => {
        setAccountDetailsForm(prev => ({ ...prev, [key]: value }))
    }

    const allMandatoryFieldsEntered = () => {
        for (const [key, value] of Object.entries(accountDetailsForm)) {
            if (!["attachmentKey", "id"]?.includes(key) && !value) return false;
        }
        return true;
    };

    const isValidForm = () => {
        const { accountNumber, ifscCode } = accountDetailsForm;

        if (accountNumber?.length < 9) {
            failureToast("Account number must be atleast 9 digit long!");
            return false;
        }

        if (!regex.ifscCode.test(ifscCode)) {
            failureToast("Please enter valid IFSC code!");
            return false;
        }

        return true;
    }

    const saveHandler = async () => {
        try {
            setLoading(true);

            if (!isValidForm()) return;

            const resp = await addEditBankDetails(accountDetailsForm);
            if (resp?.code === 200) {
                // successToast("Request completed successfully!");
                // closeDialog();
                setAddEditSuccessDialogOpen(true);
                await getAllBankAccounts();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }

    }

    const dialogHeading = viewOnly ? 'Bank account' : forEdit ? 'Edit bank account' : 'Add a new bank account';

    return (
        <Dialog
            open={!!isOpen}
            maxWidth={"md"}
            fullWidth
        >
            <div className={`${styles['dialog-container']}`}>

                {loading && <ALoader position={"fixed"}/>}
                
                <div className='d-flex justify-content-between'>
                    <div className={`${styles['dialog-heading']}`}>{dialogHeading}</div>
                    <div className='d-flex'>
                        <ScanChequeCta />
                        <CrossIcon className='ml-2' onClick={closeDialog} />
                    </div>
                </div>

                <div className={`${styles['form']}`}>
                    <AAutoComplete
                        label='Bank*'
                        currentValue={accountDetailsForm?.bank}
                        handleChange={(val) => {
                            formHandler("bank", val);
                            const bankCountry = allCountries?.find(country => country?.value === val?.countryCodeVal);
                            formHandler("country", bankCountry);
                        }}
                        items={allBanks}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />

                    <AAutoComplete
                        isDisabled
                        label='Country*'
                        currentValue={accountDetailsForm?.country}
                        items={allCountries}
                        isMulti={false}
                    />

                    <div>
                        <AInput
                            label="Account Number*"
                            placeholder="Enter"
                            value={accountDetailsForm?.accountNumber}
                            handler={(val) => {
                                formHandler("accountNumber", val);
                            }}
                            regex={regex.numeric}
                            maxLength={18}
                            disabled={viewOnly}
                        />
                    </div>

                    <AAutoComplete
                        label='Account Type*'
                        currentValue={accountDetailsForm?.bankAccountType}
                        handleChange={(val) => {
                            formHandler("bankAccountType", val);
                        }}
                        items={bankAccountTypes}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />

                    <AAutoComplete
                        label='Beneficiary Type*'
                        currentValue={accountDetailsForm?.accountType}
                        handleChange={(val) => {
                            formHandler("accountType", val);
                        }}
                        items={userTypes}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />

                    <AAutoComplete
                        label='Student Relation*'
                        currentValue={accountDetailsForm?.studentRelation}
                        handleChange={(val) => {
                            formHandler("studentRelation", val);
                        }}
                        items={studentRelationDropdown}
                        isMulti={false}
                        isDisabled={viewOnly}
                    />

                    <div>
                        <AInput
                            label="IFSC Code*"
                            placeholder="Enter"
                            value={accountDetailsForm?.ifscCode}
                            handler={(val) => {
                                formHandler("ifscCode", val?.toUpperCase());
                            }}
                            regex={regex.alphaNumeric}
                            maxLength={11}
                            disabled={viewOnly}
                        />
                    </div>

                    <div>
                        <AInput
                            label="Name on Account*"
                            placeholder="Enter"
                            value={accountDetailsForm?.beneficiaryName}
                            handler={(val) => {
                                formHandler("beneficiaryName", val);
                            }}
                            regex={regex.alphabetsWithSpace}
                            disabled={viewOnly}
                        />
                    </div>

                    <div>
                        <AInput
                            label="Beneficiary Branch*"
                            placeholder="Enter"
                            value={accountDetailsForm?.beneficiaryBranch}
                            handler={(val) => {
                                formHandler("beneficiaryBranch", val);
                            }}
                            regex={regex.alphaNumericWithSpaceAndUnderscore}
                            disabled={viewOnly}
                        />
                    </div>

                    <UploadDocument
                        attachmentKey={accountDetailsForm?.attachmentKey}
                        setUploadDialogOpen={setUploadDialogOpen}
                        formHandler={formHandler}
                        viewOnly={viewOnly}
                    />

                    <SelectStatus
                        bankStatus={accountDetailsForm?.bankStatus}
                        formHandler={formHandler}
                        disabled={viewOnly}
                    />

                </div>

                {
                    !viewOnly &&
                    <AButton
                        variant='primary_filled'
                        className='no-ml-btn'
                        disabled={!allMandatoryFieldsEntered()}
                        onClick={saveHandler}
                    >
                        {forEdit ? "Update changes" : "Save"}
                    </AButton>
                }

                {(forEdit) && <div className={styles['update-info'] + " mt-2"}>Updated on {getFormatedDate(updatedOn, "DD/MM/YYYY")} by {updatedBy}</div>}

                <DocUploadModal
                    open={uploadDialogOpen}
                    setOpen={setUploadDialogOpen}
                    acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
                    maxUploadFileSize={5}
                    serviceName={'STUDENT_BANK_ATTACHMENT'}
                    uniqueKeyParameter={"studentBankAccountDetails"}
                    uploadedFileS3Key={accountDetailsForm?.attachmentKey}
                    uploadedFileName={"Account Details"}
                    modalTitle={"Upload Attachment"}
                    saveHandler={(s3Key) => {
                        setUploadDialogOpen(false);
                        formHandler("attachmentKey", s3Key)
                    }}
                    modalProps={{ zIndex: 1500 }}
                    key={accountDetailsForm?.attachmentKey}
                />

                <ApprovalSentSuccessDialog
                    heading={`Beneficiary has been ${forEdit ? 'updated' : 'added'} for PSID ${accountDetailsForm?.psid}`}
                    subHeading={`${forEdit ? 'Updated' : 'Created'} on ${getFormatedDate(new Date(), 'DD/MM/YYYY')} by ${userDetails?.employeeId}(${userDetails?.firstName} ${userDetails?.lastName})`}
                    closeCb={closeDialog}
                    open={addEditSuccessDialogOpen}
                    setOpen={setAddEditSuccessDialogOpen}
                    disableScrollLock
                />

            </div>

        </Dialog>
    );
}

export default AddEditBankAccountDialog;